import axios from '../api/index.js';

//查询首页轮播列表
export let getAwardQuery = (params) => {
    return axios.post(`/client/dedicate/list`,params);
};

//查询首页轮播介绍详情
export let getAwardContent = (params) => {
    return axios.get(`/client/dedicate/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/award.js